export default "__VITE_ASSET__s3Pwu9WK__"